import { ITableColumn } from "@interfaces/common.interfaces";

const saveBlob = (blob: Blob, filename: string): void => {
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = filename;
    a.click();
    URL.revokeObjectURL(url);
};

const csvCell = (col: ITableColumn<any>, item: any): string => {
    if (col.getExportValue) {
        // Trust the existing convention: callbacks that wrap nested data
        // via escapeForExport already return RFC 4180-quoted fields.
        return col.getExportValue(col.key, item);
    }
    const raw = String((item as any)[col.key] ?? "");
    if (/[,"\r\n]/.test(raw)) {
        return `"${raw.replace(/"/g, '""')}"`;
    }
    return raw;
};

const csvHeader = (label: string): string => {
    if (/[,"\r\n]/.test(label)) {
        return `"${label.replace(/"/g, '""')}"`;
    }
    return label;
};

export function downloadAsCsv(
    columns: Array<ITableColumn<any>>,
    items: ReadonlyArray<any>,
    filenamePrefix: string,
): void {
    const exportable = columns.filter(c => c.showInExport !== false);

    const headerLine = exportable.map(c => csvHeader(String(c.label))).join(",");
    const dataLines = items.map(item =>
        exportable.map(col => csvCell(col, item)).join(",")
    );

    const BOM = "﻿";
    const content = BOM + [headerLine, ...dataLines].join("\r\n") + "\r\n";
    const blob = new Blob([content], { type: "text/csv;charset=utf-8" });
    saveBlob(blob, `${filenamePrefix}.csv`);
}
